module.exports = __webpack_public_path__ + "img/FR10128.236f39db.png";